export const ImageView = ({ label, value = "" }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      <div className="w-[10rem] h-[10rem] my-1 rounded-lg">
        <img
          src={value}
          className="w-full h-full rounded-lg"
          alt={`${label}-image`}
        />
      </div>
    </div>
  );
};

export const ImageViewArray = ({ label, value = [] }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
        {label}
      </h1>
      <div className="flex flex-wrap gap-5 items-center">
        {value?.map((item, index) => (
          <div key={index} className="w-[10rem] h-[10rem] my-1 rounded-lg">
            <img
              src={item}
              className="w-full h-full rounded-lg"
              alt={`${label}-image`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
